var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google logo",
    clipPath: "url(#clip0_343_12000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875488 40.0441V8.72712C0.875852 7.85262 1.22331 7.01402 1.84155 6.39553C2.45979 5.77704 3.29824 5.42923 4.17274 5.4285H35.4884L0.875488 40.0441Z",
    fill: "#1EA361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875398 40.7V40.0427L35.4897 5.43124H36.1469C37.0214 5.43161 37.86 5.77907 38.4785 6.3973C39.097 7.01554 39.4448 7.85399 39.4455 8.72849V9.38849L4.83127 44H4.17127C3.29677 43.9993 2.45832 43.6515 1.84008 43.033C1.22185 42.4145 0.874388 41.5759 0.874023 40.7014",
    fill: "#FEDB43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83105 44L20.1623 28.6715L35.4894 44H4.83105Z",
    fill: "#5384C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4895 44L20.1597 28.6688L24.1142 24.7129L39.4454 40.0441V40.7014C39.4451 41.5761 39.0974 42.4149 38.4789 43.0335C37.8603 43.652 37.0215 43.9996 36.1468 44H35.4895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4455 40.0441L24.1143 24.7129L39.4455 9.38162V40.0441Z",
    fill: "#C2C2C1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.7548 9.69375C9.71692 8.79588 12.1727 9.16163 13.7663 10.6315L12.2428 12.144C10.6478 10.5628 7.65442 11.3121 6.9078 13.4049C5.9453 15.4646 7.55405 18.172 9.8503 18.2009C11.3532 18.3755 12.8533 17.369 13.1709 15.8716C12.1204 15.873 11.0727 15.8634 10.0249 15.8799L10.0057 13.937L15.2857 14.0085C15.4177 15.2914 15.3269 16.6526 14.6367 17.776C13.5545 19.789 11.0012 20.669 8.83967 20.1603C6.16805 19.6061 4.1688 16.8658 4.53317 14.1515C4.7188 12.2375 6.0003 10.4871 7.7548 9.69375Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M32.7082 0H33.9622C37.0876 0.17875 40.1428 1.705 42.0362 4.21712C43.2765 5.80387 43.9695 7.77287 44.1262 9.77213V10.5146C44.0533 14.3921 41.5728 17.5739 39.4237 20.5893C37.012 23.9965 34.7845 27.7118 34.1657 31.9096C34.0007 32.6205 34.1987 33.6174 33.349 33.9377C33.1496 33.7824 32.9158 33.6531 32.7756 33.4359C32.524 31.0887 31.9506 28.7691 30.9358 26.6255C29.7987 24.1271 28.2175 21.868 26.6087 19.6611C25.6297 18.337 24.7071 16.9661 23.944 15.5031C22.745 13.3127 22.2981 10.725 22.789 8.26787C23.1905 6.34288 24.2052 4.52787 25.6118 3.13912C27.5052 1.287 30.0668 0.165 32.7082 0ZM32.4648 6.82825C30.9826 7.15825 29.7382 8.47 29.6131 9.99075C29.5524 10.7045 29.7066 11.4202 30.0561 12.0455C30.4055 12.6709 30.9341 13.1774 31.5738 13.4998C32.2737 13.8566 33.0648 13.9948 33.8442 13.8965C34.6237 13.7982 35.3556 13.4679 35.945 12.9484C36.4806 12.4608 36.8549 11.8214 37.0178 11.1156C37.1807 10.4097 37.1244 9.67104 36.8566 8.998C36.187 7.32325 34.2028 6.369 32.4648 6.798",
    fill: "#DC4B3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.4648 6.82824C34.2014 6.38412 36.1883 7.33699 36.8565 9.02824C37.4065 10.3661 37.027 12.0202 35.9449 12.9786C35.3555 13.4981 34.6236 13.8284 33.8442 13.9268C33.0647 14.0251 32.2737 13.8868 31.5738 13.53C30.295 12.8975 29.4563 11.4496 29.613 10.021C29.7505 8.48649 30.9825 7.17474 32.4648 6.85849",
    fill: "#802C27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_12000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglemap);
export default __webpack_public_path__ + "static/media/googlemap.589579e0f5c2a44e7f95b3801630d29a.svg";
export { ForwardRef as ReactComponent };